/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

import * as io from 'io-ts';
import { BillerInvoiceStatus } from '../BillerInvoiceStatus/BillerInvoiceStatus.entity';

/**
 * The biller invoice, and its properties.
 */
export type EntityBillerInvoice = io.TypeOf<typeof BillerInvoice>;

/**
 * The biller invoice, and its properties.
 * @export
 */
export const BillerInvoice = io.type(
  {
    currency: io.string,
    dueAmount: io.string,
    dueDate: io.string,
    issueDate: io.string,
    number: io.string,
    publicUrl: io.string,
    sequenceNumber: io.number,
    status: BillerInvoiceStatus,
    subscriptionId: io.number,
    totalAmount: io.string,
  },
  `BillerInvoice`,
);
